import React from 'react';

import { SUCCESS_MESSAGE_TEST_ID, ERROR_MESSAGE_TEST_ID } from '../../constants/testId';
import { FormValues, ToastData } from '../../types';

import superagent from 'superagent';

const REQUEST_PATH = '/_api_misc/landings/request?type=partners_solartrip';

const SUCCESS_TOAST: ToastData = {
  message: (
    <span data-testid={SUCCESS_MESSAGE_TEST_ID}>
      Thank you for submitting the form! We'll contact you soon using the provided info
    </span>
  ),
  backgroundColor: '#3CC763',
};
const ERROR_TOAST: ToastData = {
  message: <span data-testid={ERROR_MESSAGE_TEST_ID}>Something went wrong</span>,
  backgroundColor: '#e74c3c',
};

const FormRequest = async ({ values }: { values: FormValues }) => {
  return superagent
    .post(`${REQUEST_PATH}&name=${values.name}&phone=${values.phone}&email=${values.email}`)
    .then(() => {
      return SUCCESS_TOAST;
    })
    .catch(() => {
      return ERROR_TOAST;
    });
};

export default FormRequest;
